import React from 'react';

const SecondPage = () => {
  return (
    <div className="page-section">
      <div className="container">
        <div className="row align-center">
          <div className="col-md-12 text-center title-text">
            &beta; Nicotinamide Mononucleotide (NMN) <br />
            Sản phẩm đầu tiên được chứng minh khoa học giúp kéo dài tuổi thọ
          </div>
        </div>
        <div className="row align-center mt-4">
          <div className="col-md-6 text-center p-0">
            <img src="/images/nmn7.png" alt="Product" style={{ maxWidth: '100%', width: '100%' }} loading="lazy" />
          </div>
          {/* <div className="col-md-6 text-center p-0">
            <img src="/images/text.svg" alt="Product" style={{ height: '100%', maxWidth: '100%' }} loading="lazy" />
          </div> */}
          <div className="col-md-6 text-center p-0">
              <div className="row align-center mt-4">
              <div className="col-md-12 text-center body-text">
                &beta; Nicotinamide mononucleotide (NMN) là phân tử quan trọng <span className="d-none d-xl-inline"><br /></span>tham gia vào quá trình tạo ra NAD+ (Nicotinamide Adenine <span className="d-none d-xl-inline"><br /></span> Dinucleotide) – một loại coenzyme thiết yếu cho các quá trình <span className="d-none d-xl-inline"><br /></span> sống còn của tế bào như trao đổi chất, sửa chữa DNA,<span className="d-none d-xl-inline"><br /></span> tăng trưởng và duy trì sự sống của tế bào.
              </div>
            </div>
            <div className="row align-center mt-4">
              <div className="col-md-12 text-center body-text">
                NMN cũng giúp tăng mức ATP, hỗ trợ sản xuất năng lượng <span className="d-none d-xl-inline"><br /></span>của tế bào và kích hoạt sirtuin (SIRT)-các enzyme đóng vai trò <span className="d-none d-xl-inline"><br /></span>quan trọng trong việc bảo vệ tế bào, làm chậm quá trình <span className="d-none d-xl-inline"><br /></span>lão hóa và thúc đẩy tuổi thọ.
              </div>
            </div>
            <div className="row align-center mt-4">
              <div className="col-md-12 text-center body-text">
                Việc tăng NAD+ và kích hoạt sirtuin thường xuyên <span className="d-none d-xl-inline"><br /></span>thông qua việc bổ sung NMN giúp duy trì sức sống<span className="d-none d-xl-inline"><br /></span> trẻ trung, lão hóa lành mạnh và kéo dài tuổi thọ của tế bào.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecondPage;
